import { getSupabase } from "../../lib/supabase";

export type ActivityEventType = "report" | "check_in" | "issue";

export type ActivityEvent = {
  event_id: string;
  event_type: ActivityEventType;
  event_subtype: string | null;
  station_id: string;
  station_name: string;
  user_id: string | null;
  created_at: string;
  summary: string;
};

export async function getActivityFeed(limit = 30): Promise<ActivityEvent[]> {
  const sb = getSupabase();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { data, error } = await (sb as any).rpc("community_activity_feed", { p_limit: limit });
  if (error) throw new Error(`getActivityFeed failed: ${error.message}`);
  return (data ?? []) as ActivityEvent[];
}
